module.exports = __webpack_public_path__ + "img/11-1_03.aa121d96.jpg";